import UILayout from "components/layout/UILayout";
import styled, { css } from "styled-components";

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  & > * {
    max-width: 420px;
    margin: 0 auto;

    text-align: center;
  }
`;

export const Timeline = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding: 24px 12px 0;

  & > * {
    position: relative;
  }
`;

export const SlideLabel = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);

  padding: 4px 8px;

  border-radius: ${(props) => props.theme.borderRadius.micro}px;
  box-shadow: 0 0 0 1.5px ${(props) => props.theme.colors.disabled} inset;
  background: ${(props) => props.theme.colors.background};
`;

export const TimelineBackground = styled.div`
  position: absolute;
  top: 0;
  right: 0;

  width: 50%;
  height: 100%;

  background: ${(props) => props.theme.colors.disabled}22;
`;

export const TimelineDivider = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-0.75px);

  height: 100%;

  --border-color: ${(props) => props.theme.colors.disabled};
  border-right: 1.5px dashed var(--border-color);
  opacity: 0.5;

  &::after {
    content: "";
    position: absolute;
    left: -5.25px;
    bottom: -9px;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 9px solid var(--border-color); /* Arrowhead color */
  }
`;

export const Balances = styled.div`
  width: 100%;
  display: flex;
  width: 100%;
  gap: 24px;

  & > * {
    width: calc((100% - 24px) / 2);
  }
`;

export const StartBalances = styled(Balances)``;

export const EndBalances = styled(Balances)``;

export const TransactionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const TransactionWrapper = styled.div<{ isActive?: boolean }>`
  display: flex;
  width: 100%;

  & > * {
    width: calc((100% - 24px) / 2);
  }

  ${(props) =>
    props.isActive &&
    css`
      justify-content: flex-end;
    `}
`;

export const EarningsDisabledMessage = styled.div`
  position: absolute;
  top: 0;
  right: 0;

  padding: 12px;
  width: calc((100% - 24px) / 2);

  border-radius: ${(props) => props.theme.borderRadius.small}px;
  background: ${(props) => props.theme.colors.disabled}44;

  text-align: center;
`;

export const Wrapper = styled(UILayout)<{ $isCashflowActive?: boolean }>`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 48px;

  ${(props) =>
    props.$isCashflowActive &&
    css`
      ${SlideLabel} {
        color: ${props.theme.reverseColors.primary};
        background: ${props.theme.colors.primary};
        box-shadow: none;
      }

      ${TimelineBackground} {
        background: ${props.theme.colors.tertiary}22;
      }

      ${TimelineDivider} {
        --border-color: ${props.theme.colors.primary};
      }
    `}
`;
